// The signed-in user's display density (lib/density.ts), read and set from Settings and the command
// palette, and applied to the page while the workspace is mounted.
import { useCallback, useLayoutEffect, useSyncExternalStore } from 'react';
import { type Density, applyDensity, readDensity, subscribeDensity, writeDensity } from '../lib/density.ts';
import { useWorkspace } from './workspace.tsx';

export function useDensity(): [Density, (density: Density) => void] {
  const { userId } = useWorkspace();
  const density = useSyncExternalStore(subscribeDensity, () => readDensity(userId), () => 'comfortable' as const);
  const set = useCallback((next: Density) => writeDensity(userId, next), [userId]);
  return [density, set];
}

/** Puts html[data-density] in step with the user's choice; signing out returns to comfortable. */
export function useApplyDensity(): void {
  const [density] = useDensity();
  useLayoutEffect(() => { applyDensity(density); }, [density]);
  useLayoutEffect(() => () => applyDensity(null), []);
}
